// Stimulus manifest. The shared controllers come from the fvbox gem (it is a yarn
// dependency pointing at vendor/fvbox); register your own below.
import { application } from "fvbox/application"
import { registerFvboxControllers } from "fvbox"

registerFvboxControllers(application)

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import InviteController from "./invite_controller"
application.register("invite", InviteController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import ComposeController from "./compose_controller"
application.register("compose", ComposeController)

import ProfilesController from "./profiles_controller"
application.register("profiles", ProfilesController)
